const mixin = {
  methods: {
    openLink (url) {
      window.open(url, '_blank')
    }
  }
}

export default mixin
